import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Component
import PriceTextBlock from '../PriceTextBlock';

// Styles
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const SharingDiscountText = ({
  label, price, expirationText, indSaleConnected, discount,
}) => (
  <div className={cx('block')}>
    <div
      className={cx('label')}
      dangerouslySetInnerHTML={{ __html: label }}
    />
    <div className={cx('value')}>
      <div className={cx('price')}>
        <PriceTextBlock
          indSaleConnected={indSaleConnected}
          price={price}
          discount={discount}
        />
      </div>
      {expirationText && (
      <div
        className={cx('expiration-date')}
        dangerouslySetInnerHTML={{ __html: expirationText }}
      />
      )}
    </div>
  </div>
);

SharingDiscountText.propTypes = {
  label: PropTypes.string,
  price: PropTypes.string,
  expirationText: PropTypes.string,
  discount: PropTypes.string,
  indSaleConnected: PropTypes.bool,
};

export default SharingDiscountText;
